import { render, staticRenderFns } from "./ExternalSlingshot.vue?vue&type=template&id=056e58f3&scoped=true"
import script from "./ExternalSlingshot.vue?vue&type=script&lang=js"
export * from "./ExternalSlingshot.vue?vue&type=script&lang=js"
import style0 from "./ExternalSlingshot.vue?vue&type=style&index=0&id=056e58f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e58f3",
  null
  
)

export default component.exports